import { formatDateForAPI } from "@utils/datetime";

const dateQuery = (date: Date) =>
  new URLSearchParams({ date: formatDateForAPI(date) }).toString();

export const getStatusByDate = (fetch: Client.HttpClient) => (date: Date) =>
  fetch.get<Sentinel.Timeline.StatusTimelineResponse>(
    `/api/timeline/status?${dateQuery(date)}`
  );

export const getManagement = (fetch: Client.HttpClient) => (date: Date) =>
  fetch.get<Sentinel.Timeline.New>(
    `/api/timeline/management?${dateQuery(date)}`
  );

export const getGantt = (fetch: Client.HttpClient) => (date: Date) =>
  fetch.get<Sentinel.Timeline.GanttResponse>(
    `/api/timeline/gantt?${dateQuery(date)}`
  );
